import { timingSafeEqual } from "crypto";

export default class DashboardController {
    constructor(DashboardService, moment, ProfilePermissionsService, Notification, $translate, ContentService, $uibModal, AccountInformationService) {
        this.service = DashboardService;
        this.moment = moment;
        this.permissionsService = ProfilePermissionsService;
        this.notify = Notification;
        this.trans = $translate.instant;
        this.contentService = ContentService;
        this.modal = $uibModal;
        this.accountService = AccountInformationService;
    }

    $onInit() {
        this.subscriptions = [];

        const _ = this.trans;
        this.ordersTranslations = {
            APPLYDISCOUNT: "Discount",
            BILLPAYMENT: "Close Bill",
            BROKEN: "BROKEN",
            DRAWERINTERACTION: "DRAWERINTERACTION",
            INFORMATIONALORDER: "INFORMATIONALORDER",
            INVOICEPRINTED: "Bill Print",
            ITEMCANCELLATION: "Cancel Item",
            ITEMRETURN: "Return Item",
            NEWBILL: "New Bill",
            NEWORDER: "-",
            NEXTREQUESTED: "Request Next",
            OTH: "OTH",
            OTHINFO: "OTHINFO",
            PAYMENTTYPECHANGED: "Change Payment Type",
            REVERSEBYPAYMENTTYPECHANGED: "Rollback Payment Type Change",
            SEPARATION: "SEPARATION",
            TABLECANCELLATION: "Cancel Table",
            TRANSFERINFO: "TRANSFERINFO",
            TRANSFERITEMTOTABLE: "Transfer Item",
            TRANSFERTABLETOCASHIER: "Transfer Vendor",
            UNDODISCOUNT: "Rollback Discount"
        };

        this.currentProfile = this.permissionsService.getProfile();
        this.profileTimezone = this.currentProfile.account_timezone;

        this.accountClosingHour;

        this.subscriptions.push(
            this.closingHourObservable.subscribe((closingHour) => {
                const recentOrdersPermission = this.permissionsService.hasPermission('recent-orders');
                const recentSalesPermission = this.permissionsService.hasPermission('recent-sales');

                if (recentOrdersPermission || recentSalesPermission) {
                    if (closingHour && typeof closingHour === 'string') { this.accountClosingHour = closingHour; }

                    if (!this.accountClosingHour) { return; }

                    var currentDate = this.moment().tz(this.profileTimezone);
                    if (this.accountClosingHour && currentDate.hours() < Number(this.accountClosingHour.replace(':00', '')) - 1) {
                        // We're still in the previous day
                        currentDate.hours(-1);
                    }
                    currentDate = currentDate.format();
        
                    this.ordersCommands = Object.keys(this.ordersTranslations);
                    if (recentOrdersPermission) {
                        this.subscriptions.push(
                            this.service.getCashierList( currentDate)
                                .subscribe(cashiers => this.cashiers = cashiers)
                        );
                        this.loadOrders( currentDate );
                    }
                    if (recentSalesPermission) {
                        this.loadSales( currentDate );
                    }
                }
            })
        );
    }
    $onDestroy() {
        this.service.stopAllPolling();
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    loadOrders(ordersDate) {
        this.subscriptions.push(
            this.service.getRecentOrders(
                ordersDate, this.cashierId, this.tableCode, this.widgetALimit
            ).subscribe(data => this.orders = data.orders)
        );
    }

    loadSales(salesDate, offset) {
        this.subscriptions.push(
            this.service.getRecentSales(salesDate, offset).subscribe(data => {
                this.sales = data.sales;
            })
        );
    }

    reapplyFirstWidgetFilters() {
        if (this.filterBy === 'B') {
            this.tableCode = this.tableCode || undefined;
            this.cashierId = undefined;          
        } else if (!Number.isNaN(parseInt(this.filterBy))) {
            this.cashierId = this.filterBy;
            this.tableCode = undefined;
        } else {
            this.tableCode = undefined;
        }

        var currentDate = this.moment().tz(this.profileTimezone);
        if (this.accountClosingHour && currentDate.hours() < Number(this.accountClosingHour.replace(':00', '')) - 1) {
            // We're still in the previous day
            currentDate.hours(-1);
        }
        currentDate = currentDate.format();
        this.loadOrders(currentDate);
    }

    reapplySecondWidgetFilters() {
        var salesDate = this.moment().tz(this.profileTimezone),
            offset;

        if (this.salesSince == 'today') {
            offset = undefined;
        }
        else if (this.salesSince == 'yesterday') {
            salesDate.subtract(1, 'days');
            offset = undefined;
        }
        else if (!Number.isNaN(parseInt(this.salesSince))) {
            offset = this.salesSince;
        }
        this.loadSales(salesDate.format(), offset);
    }

    dangerousRows(desc) {
        var dangerous = ['BILLPAYMENT', 'APPLYDISCOUNT'];
        return dangerous.indexOf(desc) > -1;
    }

    getTotal(item) { return item.total; }

    openModalClosingHour() {
        const _ = this.trans;
        const that = this;

        this.modal.open({
            animation: true,
            size: 'lg',
            templateUrl: 'closing-hour-template.html',
            appendClassName: 'ngdialog-theme-plain',
            controller: ($scope, $state, $uibModalInstance) => {
                "ngInject";
                
                const subscription = that.contentService.getClosingHour()
                    .subscribe((hour) => $scope.hour = hour || '01:00');

                $scope.closeThisDialog = () => {
                    $uibModalInstance.close();
                    subscription.unsubscribe();
                };
                $scope.updateHour = () => {
                    that.contentService.updateClosingHour($scope.hour).subscribe(() => {
                        that.notify.success(_('El horario de ciere ha sido actualizado exitosamente.!'));
                        $scope.closeThisDialog();
                    });
                    subscription.unsubscribe();
                };
            }
        });
    }
}

DashboardController.$inject = ['DashboardService', 'moment', 'ProfilePermissionsService', 'Notification', '$translate', 'ContentService', '$uibModal', 'AccountInformationService'];


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.controller.js